import { Tooltip } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { permissionError } from "../../util/Alert";
//routing
import { Link, useHistory } from "react-router-dom";
//pagination
import Pagination from "../../pages/Pagination";
//image
import Male from "../../assets/images/male.png";
import { connect, useDispatch, useSelector } from "react-redux";

import {
  getCoinSeller,
  showCoinSeller,
  deleteCoinSeller,
  resetCoinSellerAuthenticator,
} from "../../store/coinSeller/action";
import {
  ADD_MONEY_OPEN_DIALOGUE,
  OPEN_COINSELLER_DIALOGUE,
} from "../../store/coinSeller/type";
import CoinSellerAdd from "../dialog/coinSellerAdd";
import dayjs from "dayjs";
import CoinSellerAddCoin from "../dialog/CoinSellerAddCoin";

const CoinSeller = (props) => {
  const { coinSeller } = useSelector((state) => state.coinSeller);
  const [data, setData] = useState([]);

  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("ALL");
  const dispatch = useDispatch();

  useEffect(() => {
    props.getCoinSeller();
  }, []);

  useEffect(() => {
    setData(coinSeller);
  }, [coinSeller]);

  const handleBlockUnblockSwitch_ = (data) => {
    props.liveCut(data.liveStreamingId, data?.liveUserId?._id, data?.username);
  };

  const history = useHistory();

  const handleUserInfo = (user) => {
    history.push({ pathname: "/admin/user/detail", state: user });
  };

  const handleUserHistory = (user) => {
    console.log("user", user);
    history.push({
      pathname: "/admin/diamondSeller/history",
      state: user,
    });
  };

  //   pagination

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase();
    if (value) {
      const data = coinSeller.filter((data) => {
        return (
          data?.name?.toUpperCase()?.indexOf(value) > -1 ||
          data?.email?.toString()?.indexOf(value) > -1 ||
          data?.receiveCoin?.toString()?.indexOf(value) > -1 ||
          data?.spendCoin?.toString()?.indexOf(value) > -1
        );
      });
      setData(data);
    } else {
      setData(coinSeller);
    }
  };

  const handleOpen = () => {
    dispatch({ type: OPEN_COINSELLER_DIALOGUE });
  };
  const handleEdit = (data) => {
    dispatch({ type: OPEN_COINSELLER_DIALOGUE, payload: data });
  };

  const handleShow_ = (value) => {
    props.showCoinSeller(value);
  };

  const handleDisable = (value) => {
    props.deleteCoinSeller(value);
  };

  const handleGiveCoin = (value) => {
    dispatch({ type: ADD_MONEY_OPEN_DIALOGUE, payload: value });
  };

  const handleResetAuthenticator = (seller) => {
    if (
      window.confirm(
        `Reset Google Authenticator for ${seller.email}? Existing seller sessions will be revoked immediately.`,
      )
    ) {
      props.resetCoinSellerAuthenticator(seller._id);
    }
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3" style={{ color: "#e4eeff" }}>
              Diamond Seller
            </h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active " aria-current="page">
                  Diamond Seller
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card" id="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
                  <button
                    type="button"
                    className="btn waves-effect waves-light btn-danger btn-sm float-left"
                    onClick={handleOpen}
                    id="CoinSellerAdd"
                  >
                    <i className="fa fa-plus"></i>
                    <span className="icon_margin">New</span>
                  </button>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right mt-3 mt-lg-0 mt-xl-0">
                  <form action="">
                    <div className="input-group mb-3 border rounded-pill">
                      <div className="input-group-prepend border-0">
                        <div id="button-addon4" className="btn text-danger">
                          <i className="fas fa-search mt-2"></i>
                        </div>
                      </div>
                      <input
                        type="search"
                        placeholder="What're you searching for?"
                        aria-describedby="button-addon4"
                        className="form-control bg-none border-0 rounded-pill searchBar"
                        onChange={handleSearch}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow pt-0">
              <table className="table table-striped mt-5 text-center">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile No</th>
                    <th>Receive Diamond</th>
                    <th>Spend Diamond</th>
                    <th>Diamond</th>
                    <th>Give Diamond </th>
                    <th>Created At</th>
                    <th>Show in App</th>
                    <th>Disable</th>
                    <th>Auth Status</th>
                    <th>Authenticator</th>
                    <th>Edit</th>
                    <th>History</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              height="50px"
                              width="50px"
                              alt="app"
                              src={data?.image ? data?.image : Male}
                              style={{
                                boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                border: "2px solid #fff",
                                borderRadius: 10,
                                float: "left",
                                objectFit: "cover",
                              }}
                            />
                          </td>
                          <td>{data?.name}</td>
                          <td>{data?.email}</td>
                          <td>{data?.mobileNo}</td>
                          <td>{data?.receiveCoin}</td>
                          <td>{data?.spendCoin}</td>
                          <td>{data?.coin}</td>
                          <td>
                            <Tooltip title="Give Diamond">
                              <button
                                type="button"
                                className="btn btn-sm btn-info"
                                onClick={() => handleGiveCoin(data?._id)}
                              >
                                <i className="fa fa-edit fa-lg"></i>
                              </button>
                            </Tooltip>
                          </td>
                          <td>
                            {dayjs(data?.createdAt).format("DD MMM YYYY")}
                          </td>
                          <td>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={data.isShow}
                                onChange={() => handleShow_(data._id)}
                              />
                              <span className="slider">
                                <p
                                  style={{
                                    fontSize: 12,
                                    marginLeft: `${
                                      data?.isShow ? "-22px" : "35px"
                                    }`,
                                    color: "#000",
                                    marginTop: "6px",
                                  }}
                                >
                                  {data?.isShow ? "Yes" : "No"}
                                </p>
                              </span>
                            </label>
                          </td>
                          <td>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={data.isDisable}
                                onChange={() => handleDisable(data._id)}
                              />
                              <span className="slider">
                                <p
                                  style={{
                                    fontSize: 12,
                                    marginLeft: `${
                                      data?.isDisable ? "-22px" : "35px"
                                    }`,
                                    color: "#000",
                                    marginTop: "6px",
                                  }}
                                >
                                  {data?.isDisable ? "Yes" : "No"}
                                </p>
                              </span>
                            </label>
                          </td>
                          <td>
                            <span className="badge bg-secondary">
                              {data?.authStatus || "pending_enrollment"}
                            </span>
                          </td>
                          <td>
                            <Tooltip title="Reset authenticator and revoke sessions">
                              <button
                                type="button"
                                className="btn btn-sm btn-warning"
                                onClick={() => handleResetAuthenticator(data)}
                              >
                                <i className="fas fa-sync-alt"></i>
                              </button>
                            </Tooltip>
                          </td>
                          <td>
                            <Tooltip title="Edit">
                              <button
                                type="button"
                                className="btn btn-sm btn-info"
                                onClick={() => handleEdit(data)}
                              >
                                <i className="fa fa-edit fa-lg"></i>
                              </button>
                            </Tooltip>
                          </td>
                          <td>
                            <Tooltip title="History">
                              <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={() => handleUserHistory(data)}
                              >
                                <i className="fas fa-history fa-lg"></i>
                              </button>
                            </Tooltip>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="20" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={data?.length}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
      <CoinSellerAdd />
      <CoinSellerAddCoin />
    </>
  );
};

export default connect(null, {
  getCoinSeller,
  deleteCoinSeller,
  showCoinSeller,
  resetCoinSellerAuthenticator,
})(CoinSeller);
